<p-toast></p-toast>
<ng-container>
    <div class="p-fluid grid flex justify-content-start espacio">
        <div class="col-12">
            <form
                *ngIf="formGroup && this.currentUser.superusuario"
                [formGroup]="formGroup"
            >
                <div
                    class="p-fluid p-formgrid grid justify-content-center p-0 m-0"
                >
                    <div class="field col-12 md:col-1">
                        <label htmlFor="id_empresa">Empresa</label>
                        <span class="p-input-icon-right">
                            <input
                                pInputText
                                id="id_empresa"
                                type="text"
                                formControlName="id_empresa"
                                (change)="onEmpresa()"
                                (keydown.control.enter)="onListaEmpresa()"
                            />
                            <i
                                style="font-size: 1.2rem"
                                class="pi pi-search"
                                (click)="onListaEmpresa()"
                            ></i>
                        </span>
                    </div>
                    <div class="field col-12 md:col-2">
                        <label htmlFor="nombre_empresa">Descripción</label>
                        <input
                            pInputText
                            id="nombre_empresa"
                            type="text"
                            formControlName="nombre_empresa"
                        />
                    </div>
                </div>
            </form>
        </div>
        <div
            class="col-12 md:col-3"
            *ngIf="moduloTarjeta && permisoEnviarExtracto"
        >
            <div
                class="card custom-card-style color2 flex justify-content-between align-items-center"
                (click)="onAccesoDirecto('procesos/enviar')"
            >
                <b class="mr-1">Enviar Extractos - Correo</b>
                <i class="pi pi-angle-right icon-acceso-directo"></i>
            </div>
        </div>
        <div
            class="col-12 md:col-3"
            *ngIf="moduloTarjeta && permisoImportarTarjeta"
        >
            <div
                class="card custom-card-style color2 flex justify-content-between align-items-center"
                (click)="onAccesoDirecto('procesos/importar-tarjeta')"
            >
                <b class="mr-1">Importar Tarjetas</b>
                <i class="pi pi-angle-right icon-acceso-directo"></i>
            </div>
        </div>
        <div
            class="col-12 md:col-3"
            *ngIf="moduloTarjeta && informeExtractoEnviado"
        >
            <div
                class="card custom-card-style color2 flex justify-content-between align-items-center"
                (click)="onAccesoDirecto('reportes/informe-extracto-enviado')"
            >
                <b class="mr-1">Informe de Extractos Enviados</b>
                <i class="pi pi-angle-right icon-acceso-directo"></i>
            </div>
        </div>
        <div class="col-12 md:col-3" *ngIf="moduloTarjeta">
            <div
                class="card custom-card-style color2 flex justify-content-between align-items-center"
                (click)="onAccesoDirecto('extractos-enviados')"
            >
                <b class="mr-1">Extractos Enviados - Historial</b>
                <i class="pi pi-angle-right icon-acceso-directo"></i>
            </div>
        </div>
        <div
            class="col-12 md:col-3"
            *ngIf="moduloNotificacion && permisoEnviarCorreo"
        >
            <div
                class="card custom-card-style color2 flex justify-content-between align-items-center"
                (click)="onAccesoDirectoNotificacion('procesos/enviar-correo')"
            >
                <b class="mr-1">Enviar flyer - Correo</b>
                <i class="pi pi-angle-right icon-acceso-directo"></i>
            </div>
        </div>
        <div
            class="col-12 md:col-3"
            *ngIf="moduloNotificacion && permisoImportarContacto"
        >
            <div
                class="card custom-card-style color2 flex justify-content-between align-items-center"
                (click)="
                    onAccesoDirectoNotificacion('procesos/procesar-contacto')
                "
            >
                <b class="mr-1">Importar Contactos</b>
                <i class="pi pi-angle-right icon-acceso-directo"></i>
            </div>
        </div>
        <div
            class="col-12 md:col-3"
            *ngIf="moduloNotificacion && permisoEnviarCorreo"
        >
            <div
                class="card custom-card-style color2 flex justify-content-between align-items-center"
                (click)="
                    onAccesoDirectoNotificacion('reportes/informe-notificacion')
                "
            >
                <b class="mr-1">Informe de Notificaciones Enviadas</b>
                <i class="pi pi-angle-right icon-acceso-directo"></i>
            </div>
        </div>
        <div class="col-12 md:col-3" *ngIf="moduloNotificacion">
            <div
                class="card custom-card-style color2 flex justify-content-between align-items-center"
                (click)="
                    onAccesoDirectoNotificacion('historial-notificaciones')
                "
            >
                <b class="mr-1">Historial de Notificación</b>
                <i class="pi pi-angle-right icon-acceso-directo"></i>
            </div>
        </div>
        <div
            class="col-12 md:col-3"
            *ngIf="moduloTarjeta && permisoConsultarExtracto"
        >
            <div
                class="card custom-card-style color2 flex justify-content-between align-items-center"
                (click)="onAccesoDirecto('procesos/consulta-extractos')"
            >
                <b class="mr-1">Consulta de extractos</b>
                <i class="pi pi-angle-right icon-acceso-directo"></i>
            </div>
        </div>
        <div class="col-12 md:col-3" *ngIf="permisoInformeVerificarCorreos">
            <div
                class="card custom-card-style color2 flex justify-content-between align-items-center"
                (click)="onAccesoDirecto('reportes/verificacion-correos')"
            >
                <b class="mr-1">Verificar Correos</b>
                <i class="pi pi-angle-right icon-acceso-directo"></i>
            </div>
        </div>
    </div>
    <hr />
    <div class="col-12 flex justify-content-center" *ngIf="moduloTarjeta">
        <form *ngIf="formGroup" [formGroup]="formGroup">
            <div class="p-fluid p-formgrid grid pl-5 align-items-center">
                <div class="col-12 md:col-12 flex align-items-center">
                    <label for="annio" class="mr-3">AÑO:</label>
                    <p-calendar
                        id="annio"
                        formControlName="annio"
                        dateFormat="yy"
                        view="year"
                        (onSelect)="onDateSelect($event)"
                        vappendTo="body"
                    ></p-calendar>
                </div>
            </div>
        </form>
    </div>
    <div
        class="p-fluid grid flex justify-content-between pt-2"
        *ngIf="moduloTarjeta"
    >
        <div class="col-12 md:col-3">
            <div
                class="card color-cabal flex justify-content-start align-items-center"
            >
                <i
                    class="pi pi-users"
                    style="font-size: 1.6rem; color: white"
                ></i>
                <b class="mr-1 pl-3">
                    Clientes Cabal:
                    {{ clienteCabal | currency : "" : "" : "0.0" : "es-PY" }}</b
                >
            </div>
        </div>
        <div class="col-12 md:col-3">
            <div
                class="card color-procard flex justify-content-start align-items-center"
            >
                <i
                    class="pi pi-users"
                    style="font-size: 1.6rem; color: white"
                ></i>
                <b class="mr-1 pl-3">
                    Clientes Procard:
                    {{
                        clienteProcard | currency : "" : "" : "0.0" : "es-PY"
                    }}</b
                >
            </div>
        </div>
        <div class="col-12 md:col-3">
            <div
                class="card color-cabal flex justify-content-start align-items-center"
            >
                <i
                    class="pi pi-send"
                    style="font-size: 1.5rem; color: white"
                ></i>
                <b class="mr-1 pl-3">
                    Extractos Enviados Cabal:
                    {{
                        extractoEnviadoCabal
                            | currency : "" : "" : "0.0" : "es-PY"
                    }}</b
                >
            </div>
        </div>
        <div class="col-12 md:col-3">
            <div
                class="card color-procard flex justify-content-start align-items-center"
            >
                <i
                    class="pi pi-send"
                    style="font-size: 1.5rem; color: white"
                ></i>
                <b class="mr-1 pl-3">
                    Extractos Enviados Procard:
                    {{
                        extractoEnviadoProcard
                            | currency : "" : "" : "0.0" : "es-PY"
                    }}</b
                >
            </div>
        </div>
    </div>
    <hr />
    <div
        class="p-fluid grid flex justify-content-between"
        *ngIf="moduloTarjeta"
    >
        <div class="col-12 md:col-3">
            <div class="card fondo">
                <div class="grid flex justify-content-center">
                    <div class="col-12">
                        <h3 class="chart-title pb-0">
                            <b
                                >Total Clientes:
                                {{
                                    totalClientes
                                        | currency : "" : "" : "0.0" : "es-PY"
                                }}</b
                            >
                        </h3>
                    </div>
                    <div class="flex col-12 justify-content-center">
                        <p-chart
                            type="pie"
                            [data]="data"
                            [options]="options"
                        ></p-chart>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 md:col-9">
            <div class="card fondo2">
                <div class="grid flex justify-content-center">
                    <h3 class="chart-title-extractos">
                        <b>Extractos Enviados</b>
                    </h3>
                    <p-chart
                        style="width: 100%"
                        type="bar"
                        [data]="basicData"
                        [options]="basicOptions"
                    ></p-chart>
                </div>
            </div>
        </div>
    </div>
    <div
        class="p-fluid grid flex justify-content-between"
        *ngIf="moduloNotificacion"
    >
        <div class="col-12 md:col-8">
            <div class="card fondo2">
                <div class="grid flex justify-content-center">
                    <h3 class="chart-title"><b>Notificaciones Enviadas</b></h3>
                    <p-chart
                        style="width: 100%"
                        type="bar"
                        [data]="basicDataNoti"
                        [options]="basicOptionsNoti"
                        (onDataSelect)="onNotificationBarSelect($event)"
                    ></p-chart>
                </div>
            </div>
        </div>
        <div class="col-12 md:col-4">
            <div class="card fondo">
                <div class="grid flex justify-content-center">
                    <div class="col-12">
                        <h3 class="chart-title pb-0">
                            <b>Total Notificaciones</b>
                        </h3>
                    </div>
                    <div class="flex col-12 justify-content-center">
                        <p-chart
                            type="pie"
                            [data]="datanotificacion"
                            [options]="optionsnoti"
                            (onDataSelect)="onNotificationDonutSelect($event)"
                        ></p-chart>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<app-on-lista
    [show]="showOnLista"
    [title]="tituloOnLista"
    [columns]="columnasOnLista"
    [service]="serviceOnLista"
    [recordName]="recordNameOnLista"
    [filters]="filters"
    (close)="cerrarOnLista($event)"
>
</app-on-lista>
